import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { OfferModule } from '../shared/components/offer/offer.module';
import { TopsellingOfferModule } from '../shared/components/topseling_offer/topselling_offer.module';
import { FullwidthadModule } from '../shared/components/fullwidthad/fullwidthad.module';
import { BrokenImageHome1Directive } from '../shared/directives/broken-image-home-1';
import { AppBannerModule } from '../shared/layout/app-banner/app-banner.module';
import { DirectVineOfferModule } from '../shared/components/direct-vine-offer/direct-vine-offer.module';

@NgModule({
  declarations: [
    HomeComponent,
    BrokenImageHome1Directive
  ],
  imports: [
    CommonModule,
    HomeRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    OfferModule,
    TopsellingOfferModule,
    FullwidthadModule,
    AppBannerModule,
    DirectVineOfferModule
  ]
})
export class HomeModule { }
